import type { SwipeDirection } from '../types';

/**
 * Clamps `delta` so it only represents movement in the allowed swipe direction.
 * Opposite-direction values are collapsed to zero.
 *
 * @param delta - Raw signed pixel delta.
 * @param direction - The swipe direction.
 * @returns Clamped delta.
 */
export const clampToDirection = (
    delta: number,
    direction: SwipeDirection
): number => {
    if (direction === 'left' || direction === 'up') {
        return Math.min(delta, 0);
    }

    return Math.max(delta, 0);
};
